import { useState, type PropsWithChildren } from "react";
import {
  PrimaryControlsStripOpaqueChromeContext,
  createPrimaryControlsStripOpaqueChromeRegistry,
} from "#primary-controls-strip-opaque-chrome-context";

/**
 * Wraps the subtree containing both the `NavLayout` fade and every surface that can claim opaque
 * header chrome.
 */
export function PrimaryControlsStripOpaqueChromeProvider({ children }: PropsWithChildren) {
  const [registry] = useState(() => createPrimaryControlsStripOpaqueChromeRegistry());
  return (
    <PrimaryControlsStripOpaqueChromeContext.Provider value={registry}>
      {children}
    </PrimaryControlsStripOpaqueChromeContext.Provider>
  );
}
